// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"568":"9beba1a4","844":"064292b2"}[chunkId] + ".chunk.js";
};